import { useContext, useRef, useEffect } from "react";
import { ContextProvider } from "../../../Context";
import styles from "../TransferComponent/transfer.module.css"
import { DashBoardLayout } from "../../Layout/DashBoardLayout";
import { Link } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useNavigate } from "react-router-dom";
export const RedeemReceipt = () => {
  const {
    toggleSideBar,
    isDarkMode,
    date,
  // outputValue,
  setRealInputValue,
  setRealOutputValue,
  isLoading,
        pointRateRedeemed,
        pointTransactionId,  
       pointOrderId,  
        pointAmountRedeemed, 
        pointTransactionProduct,
         pointPointsRedeemed, 
         setAlertCustom
       
  } = useContext(ContextProvider);
  
  const handleClear = () =>{
    setRealInputValue('');
    setRealOutputValue('');
    // setText(true);
  }
  const navigate = useNavigate()

  const contentRef = useRef(null);
useEffect(()=> {
  if(!pointAmountRedeemed && !pointPointsRedeemed){
    navigate(-1);
  }
})
  // ==============Share pdf Function=============
   const handleShareClick = async() => {
      const content = contentRef.current;
      if(!content) return alert("Receipt not recorded")
      if(content){
        try {
       const pdf = new jsPDF("p", "mm", "a4");
     //  alert(pdf.internal?.pageSize.getHeight())
        const canvas = await html2canvas(content,
           {scale : 2,
             useCORS : true,
             backgroundColor : `${isDarkMode ? "#000" : "#fff"}`
          }
            )
           
        const bgPdf = pdf.setFillColor(isDarkMode ? 0 : 255, isDarkMode ? 0 : 255, isDarkMode ? 0 : 255 )
        if(bgPdf){
          const pageHeight = pdf.internal.pageSize.getHeight();
          const pageWidth = pdf.internal.pageSize.getWidth();
          const imgWidth = pageWidth;
          const imgData = canvas.toDataURL("image/jpeg", 1);
          pdf.addImage(imgData, 
            "jpeg",0, 0, imgWidth, pageHeight, undefined, "FAST");
    }
       const pdfBlob = pdf.output("blob");
      const file = new File([pdfBlob], "AremxyPlug_PointRedeem_Receipt.pdf", {type : "application/pdf"})
      if (navigator.canShare && navigator.canShare({files : [file]})) {
        navigator
          .share({
            title: "AremxyPlug_PointRedeemReceipt",
            files : [file], 
          })
          .then(() => {return;})
          .catch((error) => {return;});
      }else{
      setAlertCustom({
        message : "Sharing this pdf isn't supported in your browser.",
        type : "error",
      show : true      })
      }
    }catch(error){
       setAlertCustom({
        message : "Failed to share PDF",
        type : "error",
      show : true      })
    }
      }
    };
  
    // ==============Save Pdf Function==============
    const handleSaveAsPDFClick = async() => {
      const content = contentRef.current;
      if (content) {
        const pdf = new jsPDF();
   await html2canvas(content, {
          scale : 2,
          useCORS : true,
          backgroundColor :  `${isDarkMode ? "#000" : "#fff"}`

        }).then((canvas) => { 
            const bgPdf = pdf.setFillColor(isDarkMode ? 0 : 255, isDarkMode ? 0 : 255, isDarkMode ? 0 : 255 )
        if(bgPdf){
          const imgHeight = pdf.internal.pageSize.getHeight();
          const imgWidth = pdf.internal.pageSize.getWidth();
          const imgData = canvas.toDataURL("jpeg", 1);
          pdf.addImage(imgData, "jpeg", 0, 0, imgWidth, imgHeight, "FAST");
           pdf.save("AremxyPlugAirtimeReceipt.pdf");
          pdf.setTextColor(isDarkMode? 0: 255,isDarkMode? 0: 255,isDarkMode? 0: 255 )
        } 
      }
      ).catch((error)=> {
      return;
      })
      
 }
    };
  

  // ==============Save Pdf Function==============
 
  const NairaConvertAmountRedeem = typeof pointAmountRedeemed === "string"?
 Number(pointAmountRedeemed)?.toLocaleString("en-NG", {
  style : "currency",
  currency : "NGN",
 }) :typeof transaction_amountRedeem === "number" ?
 pointAmountRedeemed?.toLocaleString("en-NG", {
  style : "currency",
  currency : "NGN",
 }) :"";
  return (
    <DashBoardLayout>
      <div className="flex flex-col gap-[35px] lg:gap-[85px]">
         <div
          className={` ${styles.receipt} ${
            toggleSideBar ? "" : "lg:w-[880px] "
          } w-full lg:mx-auto  ${isDarkMode ? "border border-white" : ""}` } 
        >
          <div className="flex justify-between items-center mx-[3%] my-[2%] lg:my-[1%]">
            <Link onClick={handleClear} to="/point-redeem">
              <img
                 className=" w-[15px] h-[10px] md:w-[24px] md:h-[15px] lg:w-[42px] lg:h-[25px]"
                src="/Images/login/arpLogo.png"
                alt=""
              />
            </Link>
            <Link onClick={ handleClear } to="/point-redeem">
              {" "}
              <img
                className=" w-[18px] h-[18px] md:w-[35px] md:h-[35px] lg:w-[29px] lg:h-[29px]"
               src="/Images/transferImages/close-circle.png"
                alt=""
              />
            </Link>
          </div>
          <hr className="h-[6px] bg-[#04177f] border-none md:h-[10px]" />
          <div ref={contentRef}>
            {" "}
           <h3 className="font-extrabold text-[12px] my-[2%] 
            text-center md:text-[20px] md:my-[3%] lg:text-[16px] lg:my-[2%]">
            Transaction Receipt
            </h3>
            <div className="w-full flex justify-center ">
              <img
                className="absolute w-[250px] h-[450px] md:w-[70%] lg:w-[50%] lg:h-[550px]"
                src="./Images/transferImages/receipt-background.jpeg"
                alt="/"
              />
            </div>
            <h3 className={`font-extrabold text-[12px]  mt-[2%] text-center 
            md:text-[20px] md:my-[7px] lg:text-[16px] lg:my-[10px]
            ${isDarkMode ? "text-white" : "text-black"}
          `}> 
            Redeem Successful on
            </h3>
            <span className={`text-[12px]  ${isDarkMode ? "text-white" : "text-black"} 
            pt-1 font-extrabold flex justify-center items-center`}>
              {date.toLocaleDateString(undefined, {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                hour12: true,
              })}
            </span>
             <p className={`text-[10px] p-[5.729px] border-[0.573px] rounded-[6.302px] md:p-[5.868px] md:border-[0.578px] md:rounded-[6.455px] lg:border lg:rounded-[11px] leading-[15px] md:leading-[20px] lg:p-2.5 text-center 
             my-2 md:text-sm lg:text-base lg:leading-6 
             font-medium md:mb-7 
             border-[#27AE60] text-[#27AE60]
              bg-[#D5F6E3]
              `}>
              You have successfully redeemed{" "}
              <span className={` font-extrabold text-[10px] md:text-[12px] lg:text-[14px]`}>
                   {isLoading ? "Loading..." : pointAmountRedeemed}
              </span>{" "}
              Points to{" "}
             <span className={`  font-extrabold text-[10px] md:text-[16px] lg:text-[14px]`}>
                  {isLoading ? "Loading..." : NairaConvertAmountRedeem}
              </span>{" "}
              from your PTS balance{" "} to
            </p>

            <div className="flex flex-col gap-5 py-5">
              {/* ========================Recipient Info================== */}
              <div className="flex flex-col gap-[3px] w-[90%] mx-auto lg:gap-[5px]">
                <div className="flex gap-[5px] items-center text-[10px] lg:text-[16px] font-extrabold">
                    <p className= {`text-[#0008]  ${isDarkMode ? "text-white" : "text-black"}`}>
                 Wallet Info</p>
                  <img
                    className="w-[13px] h-[13px] md:w-[] md:h-[] lg:w-[20px] lg:h-[20px]"
                    src="./Images/dashboardImages/arrowright.png"
                    alt="/"
                  />
                </div>
                <div className="flex text-[10px] md:text-[14px] w-[90%] mx-auto justify-between  lg:text-[16px]">
                  <p className={` ${isDarkMode ? "text-white" : "text-[#7C7C7C]"}`}>Wallet Type</p>
                  <span className={` ${isDarkMode ? "text-white": "text-black"}`}>Nigerian NGN Wallet</span>
                </div>
                <div className="flex text-[10px] md:text-[14px] w-[90%] mx-auto justify-between  lg:text-[16px]">
                  <p className={` ${isDarkMode ? "text-white" : "text-[#7C7C7C]"}`}>Amount Redeemed</p>
                    <span className={` ${isDarkMode ? "text-white" : "text-black"}`}>{isLoading ? "Loading..." : pointAmountRedeemed} PTS</span>
                </div>
                <div className="flex text-[10px] md:text-[14px] w-[90%] mx-auto justify-between  lg:text-[16px]">
                  <p className={` ${isDarkMode ? "text-white" : "text-[#7C7C7C]"}`}>Account Received</p>
                   <span className={` ${isDarkMode ? "text-white" : "text-black"}`}>&#8358;{isLoading ? "Loading..." : pointPointsRedeemed}.00 </span>
                </div>
               
                <div className="flex text-[10px] md:text-[14px] w-[90%] mx-auto justify-between  lg:text-[16px]">
                  <p className={` ${isDarkMode ? "text-white" : "text-[#7C7C7C]"}`}>Redeem Rate </p>
                  <span className={` ${isDarkMode ? "text-white": "text-black"}`}>{isLoading ? "Loading..." : pointRateRedeemed}</span>
                </div>
                
              </div>

             

              {/* ===================Transaction Info==================== */}
              <div className="flex flex-col gap-[3px] w-[90%] mx-auto lg:gap-[5px]">
                <div className="flex gap-[5px] items-center text-[10px] lg:text-[16px] font-extrabold">
                  <p  className={` ${isDarkMode ? "text-white": "text-black"}`}>Transaction Info</p>
                  <img
                    className="w-[13px] h-[13px] md:w-[] md:h-[] lg:w-[20px] lg:h-[20px]"
                    src="./Images/dashboardImages/arrowright.png"
                    alt="/"
                  />
                </div>
                <div className="flex text-[10px] md:text-[14px] w-[90%] mx-auto justify-between  lg:text-[16px]">
                  <p className={` ${isDarkMode ? "text-white" : "text-[#7C7C7C]"}`}>Product</p>
                 <span className={` ${isDarkMode ? "text-white": "text-black"}`}>{isLoading ? "Loading..." : pointTransactionProduct}</span>
                </div>
                <div className="flex text-[10px] md:text-[14px] w-[90%] mx-auto justify-between  lg:text-[16px]">
                  <p className={` ${isDarkMode ? "text-white" : "text-[#7C7C7C]"}`}>Description</p>
                 <span className={` ${isDarkMode ? "text-white": "text-black"}`}>{isLoading ? "Loading..." : pointTransactionProduct} </span>
                </div>
                <div className="flex text-[10px] md:text-[14px] w-[90%] mx-auto justify-between  lg:text-[16px]">
                  <p className={` ${isDarkMode ? "text-white" : "text-[#7C7C7C]"}`}>Completion Time</p>
                  <span className={` ${isDarkMode ? "text-white": "text-black"}`}>Instantly</span>
                </div>
                   <div className="flex text-[10px] md:text-[14px] w-[90%] mx-auto justify-between  lg:text-[16px]">
                <p className={`  ${isDarkMode ? "text-white" : "text-[#0008]"}`}>Transaction Id</p>
                {/* <span>&#8358;{transferFee}.00</span> */}
                <span className={`  ${isDarkMode ? "text-white" : "text-black"}`}>{isLoading ? "Loading..." : pointTransactionId}</span>
              </div>
                <div className="flex text-[10px] md:text-[14px] w-[90%] mx-auto justify-between  lg:text-[16px]">
                  <p className={` ${isDarkMode ? "text-white" : "text-[#7C7C7C]"}`}>Order Number</p>
              
                  <span className={` ${isDarkMode ? "text-white": "text-black"}`}>{isLoading ? "Loading..." : pointOrderId}</span>
                </div>
                
              </div>
            </div>
            <div className={`bg-[#F2FAFF] w-[90%]   mx-auto p-[8px] my-5 flex justify-between 
        items-center md:p-[9px] lg:p-[10px] rounded-[5px] lg:rounded-[10px]
         ${
                isDarkMode ? "bg-slate-800 " : "bg-[#F2FAFF]"
              }`}>
              <p className={`text-[10px] leading-[13px] text-center
             md:text-[14px] md:leading-[18px] lg:text-[14px]  font-semibold 
             ${isDarkMode ? "text-white" : "text-black"}`}>
                Earn free points on every successful transactions, redeem your
                earned points to real money, withdrawn to your bank account
                instantly.
              </p>
            </div>
          </div>

          <div className="flex w-[70%] mx-auto mb-[5%] md:w-[60%] ">
            <button
              onClick={() => {
                handleShareClick();
              }}
              className={`bg-[#04177f] w-[111px] flex justify-center items-center mx-auto cursor-pointer text-[12px] font-extrabold h-[40px] text-white rounded-[6px] md:w-[25%] md:rounded-[8px] md:text-[16px] lg:w-[163px] lg:h-[38px] lg:my-[2%]`}
            >
              Share Receipt
            </button>
            <button
              onClick={() => {
                handleSaveAsPDFClick();
              }}
               className={`bg-[#ffffff]   border-[1px] w-[111px] border-[#0003] flex justify-center items-center 
                mx-auto cursor-pointer text-[12px] font-extrabold  ${isDarkMode ? " bg-black border-1 border-white" : " bg-[#ffffff]"}
                h-[40px] rounded-[6px] md:w-[25%] md:rounded-[8px] md:text-[16px] lg:w-[163px] lg:h-[38px] lg:my-[2%]`}
            >
              Save as PDF
            </button>
          </div>
        </div>
        <div
          className={`${
            isDarkMode ? "mb-[1%]" : "mb-[5%]"
          } flex gap-[15px] justify-center items-center mt-[80px] lg:mb-[%]`}
        >
          <div className="text-[10px] md:text-[12px] lg:text-[16px]">
            You need help ?
          </div>
          <Link to="/ContactUs">
            <div
              className={`${isDarkMode ? "" : "bg-[#04177f]"} ${
                styles.contactus
              } text-[8px] p-1 text-white rounded-[8px] lg:text-[14px]`}
            >
              Contact Us
            </div>
          </Link>
        </div>
      </div>
    </DashBoardLayout>
  );
};
